export default "__VITE_ASSET__DMxYWfku__"